import bem from 'utils/bem';

export const block = bem('template-nux-overlay');
